module.exports = __webpack_public_path__ + "static/post_loading.6e52023d.gif";